import cx from 'clsx';

import styles from '../../card/Card.module.css';

type CardContentProps = {
  className?: string;
  flush?: boolean;
  children: React.ReactNode;
};

export function CardContent({ children, className, flush = false }: CardContentProps) {
  return (
    <div className={cx(styles['Card-content'], { [styles['Card-content--flush']]: flush }, className)}>{children}</div>
  );
}
